import React from 'react';
import imgResolver from '../utils/img-resolver';
import _ from 'lodash';

import ChatMessageIsReadStore from '../stores/ChatMessageIsReadStore';

import ShiftCandidatesProfile from './ShiftCandidatesProfile';

class ShiftCandidates extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            candidatesOpen: true,
            hiredOpen: true,
            activeCandidate: null,
            mobileCandidateHidden: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.candidates.length > 0 && this.state.activeCandidate === null) {
            this.setActiveCandidate(undefined, true);
        }
    }

    getProfilePicture(profile_picture) {
        if (profile_picture) {
            return <div className="candidate-header-avatar" style={{backgroundImage: 'url('+profile_picture+')'}}></div>;
        } else {
            return <div className="candidate-header-avatar" style={{backgroundImage: 'url(' + require('../styles/images/team_member.png') + ')'}}></div>;
        }
    }

    getCandidates(status) {
        const candidates = this.props.candidates || {};
        let hired_candidates = [];
        if ( status === DJ_CONST.HIRING_STATUSES.PENDING && this.props.shift.candidates_pending === 0) {
            return hired_candidates;
        }

        candidates.forEach(candidate => {
            if (this.state.activeCandidate && candidate.id == this.state.activeCandidate.id && candidate.hiring.message_count > 0) {
                ChatMessageIsReadStore.create(candidate.hiring.message_count, candidate.hiring.id);
                candidate.hiring.message_count = 0;
            }

            if (candidate.hiring.status == status) {
                let candidateRating = (
                    <div className="rating rating-small sidebar-person-rating">
                        <div className={"rating-star rating-star-" + (candidate.rating > 1 ? "active":"inactive")} />
                        <div className={"rating-star rating-star-" + (candidate.rating > 20 ? "active":"inactive")} />
                        <div className={"rating-star rating-star-" + (candidate.rating > 40 ? "active":"inactive")} />
                        <div className={"rating-star rating-star-" + (candidate.rating > 60 ? "active":"inactive")} />
                        <div className={"rating-star rating-star-" + (candidate.rating > 80 ? "active":"inactive")} />
                    </div>
                );
                // Commenting out candidateRating like this:
                candidateRating = null;
                hired_candidates.push(
                    <button key={candidate.id} onClick={this.setActiveCandidate.bind(this, candidate.id, false)} className={"sidebar-person " + (this.state.activeCandidate && candidate.id == this.state.activeCandidate.id ? "active " : "") + (candidate.user.validated ? "verified " : "")  + (candidate.sex == "m" ? "male":"female")}>
                        <div className="sidebar-person-avatar-container">
                            {this.getProfilePicture(candidate.user.profile_picture)}
                        </div>
                        <div className="sidebar-person-info">
                            <h3 className="sidebar-person-name">{candidate.user.first_name} {candidate.user.last_name}</h3>
                            {candidateRating}
                        </div>
                        {(candidate.hiring.message_count > 0 ? <div className="shift-circle"><span>{candidate.hiring.message_count}</span></div> : '')}
                        <img className="active-overflow " src={require('../styles/images/candidates_active_arrow.svg')}></img>
                    </button>
                );
            }
        });

        return hired_candidates;
    }

    setActiveCandidate(candidateId, mobileCandidateHidden=false) {
        const candidates = this.props.candidates;
        if (candidates.length === 0) {
            return;
        }
        let activeCandidate = null;
        if (typeof candidateId === 'undefined') {
            const hired = candidates.filter(candidate => {
                return candidate.hiring.status === DJ_CONST.HIRING_STATUSES.HIRED;
            });
            if (hired.length > 0) {
                activeCandidate = hired[0];
            } else {
                activeCandidate = candidates.filter(
                    candidate => candidate.hiring.status === DJ_CONST.HIRING_STATUSES.PENDING
                )[0];
            }
        } else {
            activeCandidate = _.find(candidates, candidate => {
                return candidate.id == candidateId
            });
        }
        this.setState({activeCandidate, mobileCandidateHidden});
    }

    toggleTab(menu) {
        this.setState({
            [menu]: !this.state[menu]
        });
    }

    changeCandidateStatus(status) {
        const candidate = this.state.activeCandidate;
        const shift = this.props.shift;
        candidate.hiring.status = status;
        let changeTab = shift.candidates_hired + shift.candidates_pending;

        if ([DJ_CONST.HIRING_STATUSES.CANCELLED_BY_US, DJ_CONST.HIRING_STATUSES.CANCELLED, DJ_CONST.HIRING_STATUSES.DECLINED].indexOf(status) > -1) {
            changeTab -= 1;

            if (changeTab) {
                this.setActiveCandidate();
            }

        } else {
            changeTab += 1;
            this.setState({activeCandidate: candidate});
        }

        if (changeTab == 0) {
            this.props.changeCandidateCount();
        }
    }

    getToggleButton(tag) {
        return <button className={"sidebar-collapse " + (this.state[tag] ? "" : "closed")}
                       onClick={this.toggleTab.bind(this, tag)}></button>
    }

    render () {
        const shift = this.props.shift || {};
        const messages = this.props.messages || {};
        const user = this.props.user || {};
        const candidateProfileProps = {
            user: user,
            messages: messages,
            changeCandidateStatus: this.changeCandidateStatus.bind(this),
            shift: shift,
            hiringStore: this.props.hiringStore,
            candidate: this.state.activeCandidate,
            candidateHidden: this.state.mobileCandidateHidden,
            closeCandidate: () => this.setState({mobileCandidateHidden: true}),
        };

        return (
            <div className={`shift-candidates media ${this.props.isActive ? " active" : ""}`}>
                <div className={`sidebar left ${this.state.mobileCandidateHidden ? "" : "hidden"}`}>
                    <div className={"sidebar-people sidebar-people-hired " + (this.state.hiredOpen ? "open" : "")}>
                        <div className="sidebar-title">
                            <h3>Hired ({shift.candidates_hired})</h3>
                            {shift.candidates_hired ? this.getToggleButton('hiredOpen') : null}
                        </div>
                        <div className={"sidebar-person-group " + (this.state.hiredOpen ? "open" : "")}>
                            {this.state.hiredOpen ? this.getCandidates('hired') : null}
                        </div>
                    </div>

                    <div className="sidebar-people sidebar-people-candidates">
                        <div className="sidebar-title">
                            <h3>Candidates ({shift.candidates_pending})</h3>
                            {shift.candidates_pending ? this.getToggleButton('candidatesOpen') : null}
                        </div>
                        <div className={"sidebar-person-group " + (this.state.candidatesOpen ? "open" : "")}>
                            {this.state.candidatesOpen ? this.getCandidates('pending') : null}
                        </div>
                    </div>

                    <div className="sidebar-tip">
                        <img className="sidebar-tip-icon" src={require('../styles/images/icon_info.svg')} alt="" />
                        <h3 className="sidebar-tip-title section-title">TIP</h3>
                        <p className="sidebar-tip-description">To see more candidates you should maybe increase the hourly rate.</p>
                    </div>
                </div>
                <ShiftCandidatesProfile {...candidateProfileProps} />
            </div>
        );
    }
}

export default ShiftCandidates;



/** WEBPACK FOOTER **
 ** ./app/src/components/ShiftCandidates.js
 **/